import { EditReturn } from 'lib/rpc'

export enum RPCAction {
    edit = 'RPCAction.edit',
}

export type EditAction = {
    type: RPCAction.edit
    payload: EditReturn
}

export type EditActions = EditAction
